import type { ConfigTemplate, ConfigTemplateFormValues } from './types'

const EMPTY_SENSORS = { temperature: [], magnetStatus: [], batteryIndication: [], batteryVoltage: [] }

const EMPTY_FORM: ConfigTemplateFormValues = {
  name: '',
  device: { type: '', modelId: '', modelName: '', vendorId: '' },
  smsCommands: '',
  gprsCommands: '',
  analogPortConfigs: [],
  digitalPortConfigs: [],
  sensorConfiguration: EMPTY_SENSORS,
}

export function emptyTemplateForm(): ConfigTemplateFormValues {
  return { ...EMPTY_FORM, sensorConfiguration: { ...EMPTY_SENSORS } }
}

// Wire template → wizard form: command arrays become newline-joined text.
export function templateToFormValues(template: ConfigTemplate): ConfigTemplateFormValues {
  return {
    name: template.name,
    device: template.device,
    smsCommands: template.smsCommands.map((c) => c.textMessage).join('\n'),
    gprsCommands: template.gprsCommands.map((c) => c.payload).join('\n'),
    analogPortConfigs: template.analogPortConfigs,
    digitalPortConfigs: template.digitalPortConfigs,
    sensorConfiguration: template.sensorConfiguration,
  }
}

function lines(text: string): string[] {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
}

// Wizard form → wire template body: textarea text becomes command arrays
// (blank lines dropped). id/cid are assigned by the screen / server.
export function formValuesToTemplate(values: ConfigTemplateFormValues): Omit<ConfigTemplate, 'id' | 'cid'> {
  return {
    name: values.name,
    device: values.device,
    smsCommands: lines(values.smsCommands).map((textMessage) => ({ textMessage })),
    gprsCommands: lines(values.gprsCommands).map((payload) => ({ payload, pending: false })),
    analogPortConfigs: values.analogPortConfigs,
    digitalPortConfigs: values.digitalPortConfigs,
    sensorConfiguration: values.sensorConfiguration,
  }
}
